define(["github:olado/doT@1.0.1/doT.min.js"], function(main) {
  return main;
});